import { useTable } from 'react-table'
import axios from 'axios'
import { useState, useEffect, createRef } from 'react'
import { useAuthHeader, useAuthUser } from 'react-auth-kit'
import ClosingAlert from './Alert'
import Modal from './Modal'
import Select from 'react-select'

export default function TimetableTable({ columns, data }) {
  const auth  = useAuthHeader()
  const authUser  = useAuthUser()
  const [showError, setShowError] = useState(false)
  const [classes, setClasses] = useState([])
  const [formData1, setFormData1] = useState({value: '', teacher_id: '', leson:'', day: ''})
  // const [formData2, setFormData2] = useState({value: '', teacher_id: '', leson:'', day: ''})
  // const [dataLoaded, setDataLoaded] = useState({done: false, sucssess: false, items: 0})
  // const [teachersList, setTeachersList] = useState([])
  const [errorMsg, setErrorMsg] = useState('Nepavyko įrašyti reikšmės')
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  })

  const modal = createRef()

  const config = {
    headers: {
      Authorization: auth()
    }
  }

  useEffect(() => {
    axios.get(process.env.REACT_APP_API + '/class', config)
    .then(res => {
      if(res.status === 200){
        //console.log(...res.data)
        setClasses([]) //! Pašalinti prieš buildinant
        res.data.forEach((data) => {
          setClasses(classes => [...classes, data])
        })
        // console.log(dataLoaded)
        // setDataLoaded({done: true, sucssess: true, items: res.data.length})
      }
      // axios.get(process.env.REACT_APP_API + '/teacher', config)
      // .then(res => {
      //   if(res.status === 200){
      //     setTeachersList([]) //! Pašalinti prieš buildinant
      //     res.data.forEach((data) => {
      //       setTeachersList(teachers => [...teachers, data])
      //     })
      //   }
      // })
      // .catch(err => {
      //   setTeachersList([]) //! Pašalinti prieš buildinant
      //   setTeachersList(teachers => [...teachers, err.response.data])
      //   // setDataLoaded({done: true, sucssess: false, items: 0})
      // })
    })
    .catch(err => {
      setClasses([]) //! Pašalinti prieš buildinant
      //console.log(err.response.data)
      setClasses(classes => [...classes, err.response.data])
      // setDataLoaded({done: true, sucssess: false, items: 0})
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const createEntry = (formData) => {
    axios.patch(process.env.REACT_APP_API + '/timetable', formData, config)
      .then((res)=>{
        if(res.status === 200){
          window.location.reload()
        }
      })
      .catch((err) => {
        setErrorMsg(err.response.data.message)
        setShowError(true)
      })
    }

    return (
      <>
      <ClosingAlert type='error' message={errorMsg} show={showError} updateState={(value) => {setShowError(value)}} />
      <div className='w-full pt-4 overflow-x-hidden'>
        <div className="flex flex-col">
          <div className=" sm:-mx-6 lg:-mx-8 overflow-x-auto">
            <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
              <table {...getTableProps()} className="min-w-full border-solid border-2">
                <thead className="bg-violet-500 border-b">
                  {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map(column => (
                        <th {...column.getHeaderProps()} className="text-sm font-medium text-white px-6 py-4 text-center border-solid border-2">{column.render('Header').slice(1)}</th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {rows.map((row, i) => {
                    prepareRow(row)
                    return (
                      <tr {...row.getRowProps()} className="bg-white border-b ">
                        {row.cells.map(cell => {
                          return <td {...cell.getCellProps()}
                          onClick={() => {
                            if(cell.column.parent.Header !== 'Mokytojas') {
                              modal.current.updateShow()
                              setFormData1({value: cell.value, teacher_id: cell.row.original[Object.keys(cell.row.original)[0]].id, leson: cell.column.Header.slice(1), day: cell.column.parent.Header.slice(1)})
                              // console.log(cell.value)
                              // console.log(cell.row.original[Object.keys(cell.row.original)[0]].id)
                              // console.log(cell.column.Header)
                              // console.log(cell.column.parent.Header)
                            }
                          }} 
                          className={classNames((cell.column.parent.Header !== 'Mokytojas') ? 'cursor-pointer hover:bg-gray-100' : '', 'px-6 py-4 transition duration-300 ease-in-out whitespace-nowrap text-sm font-medium text-gray-900 border-solid border-2')}>{cell.render('Cell')}</td>
                        })}
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {authUser().roles.admin &&
      <Modal title='Redaguoti' saveText='Išsaugoti' submitFunction={() => createEntry(formData1)} noBtn ref={modal}>
        <div className='pt-0'>
          <label className='text-gray-500' htmlFor="class">Klasė</label>
          <Select 
          name='value'
          defaultValue={(formData1.value !== null) ? {value: formData1.value, label: formData1.value} : null} 
          onChange={(e)=>setFormData1({...formData1, value: e.label})} 
          options={
            [{id: 0, name: 'Jokia'}, ...classes].map(sclass => {
              return ({ value: sclass.id, label: sclass.name })
            })
          } />
        </div>
      </Modal>
      }
      {/* {authUser().roles.admin &&
      <Modal showAddBtn={true} title='Redaguoti' saveText='Išsaugoti' submitFunction={() => createEntry(formData2)}>
        <div className='pt-0'>
          <label htmlFor="class">Mokytojas</label>
          <Select 
          name='lesson'
          onChange={(e)=>setFormData2({...formData2, teacher_id: e.value})} 
          options={
            teachersList.map(teacher => {
              return ({ value: teacher.id, label: teacher.person.name + ' ' + teacher.person.lastname })
            })
          } />
        </div>
        <div className='pt-3'>
          <label htmlFor="class">Pamoka</label>
          <Select 
          name='lesson'
          onChange={(e)=>setFormData2({...formData2, leson: e.value})} 
          options={
            [1, 2, 3, 4, 5, 6, 7, 8].map(lesson => {
              return ({ value: lesson, label: lesson + '-a pamoka' })
            })
          } />
        </div>
        <div className='pt-3'>
          <label htmlFor="class">Diena</label>
          <Select 
          name='day'
          onChange={(e)=>setFormData2({...formData2, day: e.value})} 
          options={
            ['Pirmadienis', 'Antradienis', 'Trečiadienis', 'Ketvirtadienis', 'Penktadienis'].map(day => {
              return ({ value: day, label: day })
            })
          } />
        </div>
        <div className='pt-3'>
          <label htmlFor="class">Klasė</label>
          <Select 
          name='class'
          onChange={(e)=>setFormData2({...formData2, value: e.label})} 
          options={
            classes.map(sclass => {
              return ({ value: sclass.id, label: sclass.name })
            })
          } />
        </div>
      </Modal>
} */}
      </>
    )
  }

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }